var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.64844 10.946H25.5403M8.5133 3.64868V6.08111M20.6755 3.64868V6.08111M7.29709 14.5946H12.162V19.4595H7.29709V14.5946ZM7.54033 25.5406H21.6484C23.0107 25.5406 23.6919 25.5406 24.2122 25.2755C24.6699 25.0422 25.042 24.6701 25.2752 24.2124C25.5403 23.6921 25.5403 23.011 25.5403 21.6487V9.97301C25.5403 8.61072 25.5403 7.92957 25.2752 7.40924C25.042 6.95155 24.6699 6.57944 24.2122 6.34623C23.6919 6.08111 23.0107 6.08111 21.6484 6.08111H7.54033C6.17804 6.08111 5.49689 6.08111 4.97657 6.34623C4.51888 6.57944 4.14676 6.95155 3.91356 7.40924C3.64844 7.92957 3.64844 8.61072 3.64844 9.97301V21.6487C3.64844 23.011 3.64844 23.6921 3.91356 24.2124C4.14676 24.6701 4.51888 25.0422 4.97657 25.2755C5.49689 25.5406 6.17804 25.5406 7.54033 25.5406Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.4d4a6c4ff3c605e0ffaaba78e7376fd4.svg";
export { ForwardRef as ReactComponent };